import React, { useCallback } from 'react';

import { View } from 'react-native';

import { LeftArrow } from 'assets/images';

import { EArrowType } from 'components/CustomButtons/ArrowButton';
import SvgButton from 'components/CustomButtons/SvgButton';

import styles from './styles';

const ICON_SIZE = {
    width: 32,
    height: 32,
};

type Props = {
    type: EArrowType;
    shouldDateChange: boolean;
    onPress: (type: EArrowType, shouldDateChange: boolean) => void;
    testID?: string;
    disabled?: boolean;
};

function EpgTimeBarArrow({
    onPress,
    type,
    shouldDateChange,
    testID = '',
    disabled = false,
}: Props) {
    const onArrowPress = useCallback(() => {
        onPress(type, shouldDateChange);
    }, [onPress, type, shouldDateChange]);

    const handleKeyDownCapture = useCallback((event: KeyboardEvent) => {
        if (event.key === 'Enter') {
            event.stopPropagation();
            event.preventDefault();
        }
    }, []);

    return (
        <View
            style={[
                styles.leftNavigationBar,
                type === EArrowType.FWD && styles.rightNavigationBar,
            ]}
        >
            <SvgButton
                style={[
                    ICON_SIZE,
                    type === EArrowType.FWD && styles.arrowFwd,
                    // @ts-ignore
                    { outline: 'none' },
                ]}
                disabled={disabled}
                Svg={LeftArrow}
                onPress={onArrowPress}
                onKeyDownCapture={handleKeyDownCapture}
                tabIndex={-1}
                testID={testID}
            />
        </View>
    );
}

export default EpgTimeBarArrow;
